export const idle = {
  id: 'idle',
  state: 'idle',
  system: true,

  enter(ctx) {
    ctx.movement.stopWalk();
    ctx.stateTimer = ctx.getStateDuration('idle');
  },

  update(ctx, dt) {
    if (!ctx.movement.isGrounded()) {
      ctx.transition('fall');
      return;
    }
    ctx.stateTimer -= dt;
    if (ctx.stateTimer <= 0) ctx.transitionToNext();
  },

  exit() {},
};
